import React from 'react';

export default class HomeLine extends React.Component {
    render() {
        return (
            <div
                style={{ width: "65px", height: "3px", backgroundColor: "#00d17b" }}
                className={this.props.className ? this.props.className : ""} ></div>
        );
    }
}